import { CallDivertInfo } from '../models/ConfigureLine';
import { CatalogImage, Device } from '../models/Devices';
import ApisClient from '../utils/client/ApisClient';

export const getAllProducts = () => {
    return ApisClient.get('/products');
};

export const getBonusOffering = (productId: string) => {
    return ApisClient.get(`/products/bonus/offering?productId=${productId}`);
};

export const getBonus = () => {
    return ApisClient.get('/products/bonus');
};

export const getBonusById = (productId: string) => {
    return ApisClient.get(`/products/bonus?productId=${productId}`);
};

export const hireBonus = (dataBonus: any) => {
    return ApisClient.post('/products/bonus/hire', dataBonus);
};

export const hireDatasharing = () => {
    return ApisClient.post('/products/datasharing/hire');
};

export const cancelDatasharing = () => {
    return ApisClient.post('/products/datasharing/cancel');
};

export const getPukInfo = (productId: string) => {
    return ApisClient.get<string>(`/products/puk?productId=${productId}`);
};

export const getCallForwardingInfo = (mobileNumber: string) => {
    return ApisClient.get<CallDivertInfo>(`/products/callforwarding?mobileNumber=${mobileNumber}`);
};

export const getDevices = () => {
    return ApisClient.get<Device[]>('/products/devices');
};

export const getCatalogImage = (imageId: string) => {
    return ApisClient.get<CatalogImage>(`/catalog/document?documentalCode=${imageId}`);
};
